
// Functionality for the main carts delivery pick up drawer
window.deliveryPickup = async function deliveryPickup(cartVariants, location, shippingData, cartTotal) {

    if (!cartVariants.length || !location || !shippingData || !cartTotal) return;

    // Strips cart total to be whole number
    const finalCartTotal = cartTotal.match(/\d+/)[0];
    let inventoryResults;

    // Gets users coordinates based on zip code
    let coords = await getCoordinatesByPostcode(location);

    // Gets product inventory data based on product ids and location
    const productIds = cartVariants.map(variant => variant.product_id);
    const inventory = await getInventoryByLocation({
        ids: productIds,
        latitude: coords.lat,
        longitude: coords.lng,
    });

    // Matches variants to there location data
    const matchingVariants = cartVariants.flatMap(cartVariant =>
        inventory
            .flatMap(inventoryItem => inventoryItem?.variants || [])
            .filter(variant => variant.id === cartVariant?.id)
    );

    // Checks availability of first store (Closest to the location)
    if (matchingVariants.length > 0) {
        inventoryResults = matchingVariants.map(variant => variant?.storeAvailability?.[0]?.available);
        if (!inventoryResults.includes(false)) {
            shippingData.clickAndCollect = true;
            shippingData.inStore = true;
        }
    } else {
        inventoryResults = []
    }

    let drawerBody = document.querySelector('.dpu-body__container');

    // Updates front end HTML
    drawerBody.innerHTML = Object.keys(shippingData)
        .filter(key => !(key === "express" && shippingData['express']?.express_enabled === false))
        .map(key => {
            const shippingType = shippingData[key];
            const fee = shippingType[key === "free" ? "standard_fee" : "express_fee"];
            const target = shippingType[key === "free" ? "standard_target" : "express_target"];
            const description = shippingType[key === "free" ? "standard_description" : "express_description"];
            const title = key === "free" ? "Standard Delivery" : key === "express" ? "Express Delivery" : key === "clickAndCollect" ? "Click & collect" : "Purchase in store";
            const storePickUp = key === "clickAndCollect" || key === "inStore";

            return `
            <div class="dpu-delivery__container flex flex-col gap-2">
                <div class="flex justify-between">
                    <p class="dpu-delivery__title bold flex uppercase font-san-serif-extended gap-1 align-center">${title} 
                        <span class="block option__status ${finalCartTotal >= target || storePickUp ? "in-stock" : "none"}"></span>
                    </p>
                    <p class="dpu-delivery__price bold uppercase font-san-serif-extended">
                        ${finalCartTotal >= target || storePickUp ? "Free" : "$" + fee.toFixed(2)}
                    </p> 
                </div>
                <div class="flex flex-col">
                    ${!storePickUp
                    ? `<p class="dpu-delivery__description font-san-serif">Free over $${target} - ${description}</p>`
                    : `
                        <p class="dpu-delivery__description font-san-serif">Brisbane</p>
                        ${key === "clickAndCollect" ? `<p class="dpu-delivery__description font-san-serif">Usually ready within 24 hours</p>` : ""}
                `
                }
                </div>
            </div>
            `;
        })
        .join('');
};
